export async function getPage(slug='home', opts={}){
  const base = process.env.REACT_APP_PUBLICATION_BASE || 'http://localhost:4300';
  const ver = opts.version ? `?v=${encodeURIComponent(opts.version)}` : '';
  const res = await fetch(`${base}/cms/pages/${encodeURIComponent(slug)}${ver}`, { cache: 'no-cache' });
  return res.json();
}

export default { getPage };
